export enum PnlLevel {
  lossLte10 = 'lossLte10',
  lossGt10Lte50 = 'lossGt10Lte50',
  lossGt50 = 'lossGt50',
  gainGt100 = 'gainGt100',
  gainGt50Lte100 = 'gainGt50Lte100',
  gainLte50 = 'gainLte50',
}
